import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'mojo-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownComponent implements DoCheck {
  @Input() active = false;
  @Input() fullWidthOnMobile = true;
  @Output() close = new EventEmitter<void>();
  @Input() closeWhenClickedInside = false;
  @ViewChild('dropdown', { static: false }) dropdown: ElementRef;
  @ViewChild('dropdownContainer', { static: false })
  dropdownContainer: ElementRef;

  /**
   * Semafor for resolving clicks outside dropdown component.
   */
  private ready = false;

  constructor(private renderer: Renderer2, private cdf: ChangeDetectorRef) {}

  toggle() {
    this.active = !this.active;
    this.ready = false;
    this.cdf.detectChanges();
  }

  ngDoCheck() {
    this.calculateStyles();
  }

  @HostListener('click', ['$event'])
  clickInside($event) {
    this.active = true;
    $event.stopPropagation();
    if (this.closeWhenClickedInside) {
      this.clickOutside();
    }
  }

  @HostListener('document:click')
  clickOutside() {
    if (this.ready) {
      if (this.active) {
        this.close.emit();
      }
      this.active = false;
    }
    this.ready = true;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.calculateStyles();
  }

  private calculateStyles() {
    if (this.dropdown && this.dropdownContainer) {
      const dropdownBounds = this.dropdown.nativeElement.getBoundingClientRect();
      const containerBounds = this.dropdownContainer.nativeElement.getBoundingClientRect();
      const containerCenter = containerBounds.left + containerBounds.width / 2;
      const windowWidth = Math.min(window.innerWidth, window.screen.width);
      if (containerCenter + dropdownBounds.width / 2 > windowWidth) {
        this.renderer.addClass(this.dropdown.nativeElement, 'right');
        this.renderer.addClass(this.dropdownContainer.nativeElement, 'static');
      } else {
        this.renderer.removeClass(this.dropdown.nativeElement, 'right');
        this.renderer.removeClass(
          this.dropdownContainer.nativeElement,
          'static',
        );
      }
    }
  }
}
